<div *ngIf="resume">
    <ng-container *ngIf="travellers.adult.count > 0">
        <strong>{{ travellers.adult.count }}</strong>
        <strong>
            {{ travellers.adult.name }}
        </strong>
        -
    </ng-container>

    <ng-container *ngIf="travellers.child.count > 0">
        <strong>{{ travellers.child.count }}</strong>
        <strong>
            {{ travellers.child.name }}
        </strong>
        -
    </ng-container>

    <ng-container *ngIf="travellers.infant.count > 0">
        <strong>{{ travellers.infant.count }}</strong>
        <strong>
            {{ travellers.infant.name }}
        </strong>
        -
    </ng-container>

    <ng-container *ngIf="travellers.rooming.count > 0">
        <strong>{{ travellers.rooming.count }}</strong>
        <strong>
            {{ travellers.rooming.count> 1 ? travellers.rooming.pluralName : travellers.rooming.name }}
        </strong>
        -
    </ng-container>
    <ng-container *ngFor="let segment of resume.segment">
        <strong>{{ segment.begin | dateMoment:dateFormat.momentMedium }}</strong> -
        <strong>{{ segment.duration.night }}</strong>

        <ng-container *ngIf="segment.duration.night > 1; else nuit">{{ labels.nights }}</ng-container>
        <ng-template #nuit>{{ labels.night }}</ng-template>

        <ng-container *ngIf="segment.end">
            - <strong>{{ segment.end | dateMoment:dateFormat.momentMedium }}</strong>
        </ng-container>

        <ng-container *ngIf="segment.property.text">
            - <strong>{{ segment.property.text }}</strong>
        </ng-container>

        <ng-container *permissionIf="permissions.SHARED_HOST_SHOW">
            <ng-container *ngIf="segment.property.host">
                - {{ labels.hosts }} <strong
                    *ngFor="let host of segment.property.host; let last = last;">{{ host | hostAlias | async }}
                <ng-container *ngIf="!last">,</ng-container>
            </strong>
            </ng-container>
        </ng-container>

        <ng-container *ngIf="segment.property.location">
            - {{ labels.location }} <strong>{{ segment.property.location }}</strong>
        </ng-container>

        <ng-container *ngIf="segment.property.geoposition">
            - {{ labels.latitude }}: <strong>{{ segment.property.geoposition.latitude | latLong }}</strong>
            - {{ labels.longitude }}: <strong>{{ segment.property.geoposition.longitude | latLong }}</strong>
            <ng-container *ngIf="segment.property?.geoposition?.radius">
                - {{ labels.radius }}: <strong>{{ segment.property?.geoposition?.radius | radius }}</strong>
            </ng-container>
        </ng-container>
    </ng-container>
    <ng-container *permissionIf="'shared.stay.quoteWithFees.view'">
        <ng-container *ngIf="resume.isOnlyRefundable">
            - <strong>{{labels.isOnlyRefundable}}</strong>
        </ng-container>
    </ng-container>
</div>
<ng-container *ngIf="!resume">...</ng-container>
